<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg12>
          <v-card pa-0>
            <v-toolbar card color="white">
              <v-text-field
              flat
              solo
              prepend-icon="search"
              placeholder="Type something"
              v-model="search"
              hide-details
              @click:prepend="showFilter = !showFilter"
              @input="searchTerm"
              ></v-text-field>     
              <!--<v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>-->              
             
              <v-btn color="blue" @click="save()" dark>
                <v-icon>save</v-icon> Simpan
              </v-btn>    
              <v-menu bottom left>
                <v-btn slot="activator" icon><v-icon>more_vert</v-icon></v-btn>
                <v-list>
                  <v-list-tile v-bind:to="{path:'/tes/rapor_excel'}">
                    <v-list-tile-title>Rekap</v-list-tile-title>
                  </v-list-tile>                       
                </v-list>
              </v-menu>                          
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text v-if="showFilter">
              <v-layout>
                <v-flex md6 xs12>
                  <v-btn-toggle class="mr-3" v-model="toggle_gender" multiple dark>
                    <v-btn small flat class="red white--text" :value="1">L</v-btn>
                    <v-btn small flat class="blue-grey white--text"  :value="2">P</v-btn>              
                  </v-btn-toggle>  
                  <v-btn-toggle v-model="toggle_tingkat" mandatory class="mr-3" dark>                
                    <v-btn round small v-for="(tingkat,i) in tingkats" :key="i" :value="tingkat.id" :color="getColor(tingkat.id)">{{tingkat.nama}}</v-btn>                
                  </v-btn-toggle> 
                </v-flex>        
              </v-layout>  
            </v-card-text>            
            <v-card-text class="pa-0 tabular">
              <v-progress-linear slot="progress" color="blue" class="pa-0 ma-0" indeterminate v-if="complex.loading"></v-progress-linear>  
              <div class="v-table__overflow">
                <table class="tb-normal">
                  <thead>
                    <tr>
                      <th rowspan="2" v-for="(header,i) in complex.headers" :key="i">
                        {{header.text}}
                      </th>
                      <template v-for="(rapor, j) in rapors" >
                        <th :key="'r'+j" :colspan="Array.isArray(rapor.childs)?(rapor.childs.length+1):0">
                          {{rapor.name}}
                        </th>                        
                      </template>
                    </tr>
                    <tr>
                      <template v-for="(rapor, j) in rapors">
                        <template v-for="(child, k) in rapor.childs">
                          <th :key="j+'.'+k">{{child.name}}</th>
                          <th :key="j+'r'+k" v-if="k == (rapor.childs.length-1)">rata2</th>
                        </template>                    
                      </template>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in complex.items" :key="i">
                      <td class="text-xs-center">{{ ((complex.pagination.currentPage-1)*20)+(i+1) }}</td>
                      <td>{{item.id}}</td>
                      <td style="min-width:190px">{{ item.nama }} ({{item.gender === 1?'L':'P'}})</td>
                      <td>{{ item.telepon }}</td>                        
                      <td  class="text-xs-center" v-if="tingkats.length > 0">
                        <template v-if="item.tingkat_id == 3">
                          {{ tingkats.find(x=>x.id==item.jurusan_id) ? tingkats.find(x=>x.id==item.jurusan_id).description : tingkats.find(x=>x.id===item.tingkat_id).description}}
                        </template>
                        <template v-else>
                          {{tingkats.find(x=>x.id==item.tingkat_id).description}}
                        </template>                    
                      </td>
                      <td>
                        <template v-if="item.calonTest && item.calonTest.kelengkapan && Array.isArray(item.calonTest.kelengkapan)">
                          <template v-for="(kelengkapan) in item.calonTest.kelengkapan">
                            <template v-if="Array.isArray(kelengkapan.file)" > 
                              <a v-for="(filename, i) in kelengkapan.file" :key="'f'+i" target="_blank" :href="$config.url+'cdn/file/berkas/'+filename">{{filename}}</a>
                            </template>
                          </template>                                                    
                        </template>
                      </td>
                      <template v-for="(rapor, j) in item.calonTest.rapors">
                        <template v-for="(child, k) in rapor.childs">
                          <td :key="j+'.'+k">
                            <input type="number" @input="setData(item)" v-model="child.nilai" style="padding:5px; max-width:45px" />
                          </td>
                          <td :key="j+'r'+k" v-if="k == (rapor.childs.length-1)" style="border-color:#ccc!important" class="text-xs-center yellow lighten-4">
                            {{parseFloat(rapor.nilai).toFixed(2)}}
                          </td>
                        </template>                    
                      </template>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="pa-2">
                <v-pagination
                  v-model="complex.pagination.currentPage"
                  :length="complex.pagination.pageCount"
                  :total-visible="9"
                ></v-pagination>
              </div>
            </v-card-text>            
          </v-card>
        </v-flex>                           
        </v-layout>
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import { debounce } from 'lodash'
import Model from '@/apps/admin/models/Calon';   
const  model = new Model();

export default {
    $_veeValidate: {
      validator: 'new'
    },    
    data: () => ({
        subtotal : 0,
        formPath : '/calon/payment/form',
        viewPath : '/calon/payment/view',
        search   : '',
        loading  : true,
        toggle_tingkat : 2,
        toggle_gender : [],
        pagination: {},
        complex  : {
            selected: [],
            headers: [
              { text: '#',   value: 'no'  },
              { text: 'ID',   value: 'id'  },
              { text: 'Nama', value: 'nama'},              
              { text: 'Telepon', value: 'telepon'}, 
              { text: 'Tingkat', value: 'tingkat_id'},  
              { text: 'Berkas', value: 'berkas'}                          
            ],
            items: [],
            loading : false,
            options : {},
            pagination:{
              totalCount: null,
              pageCount: 0,
              currentPage: 1,
              perPage: 20
            },
        },
        loadingDownload : false,
        tingkats : [],
        status   : [],
        types    : [],
        data     : [],
        rapors : [],
        showFilter : true
    }),  
    watch:{
      toggle_tingkat(newArr){
        let tingkat = null, jurusan = null;
        let ar = newArr;
        if(ar <= 3){tingkat = ar} 
        else if(ar === 7){tingkat = ar}
        else{jurusan = ar}              
        this.init(this.complex.pagination.currentPage, this.toggle_gender, tingkat, jurusan);        
      },
      toggle_gender(newArr){                
        this.init(this.complex.pagination.currentPage, newArr, this.filter.tingkat, this.filter.jurusan);        
      },
      'complex.pagination.currentPage'(newPage){        
        this.init(newPage, this.toggle_gender, this.filter.tingkat, this.filter.jurusan) 
      },
      'complex.options':{
        handler(){          
          this.init(this.complex.pagination.currentPage, this.toggle_gender, this.filter.tingkat, this.filter.jurusan)
        }, deep:true      
      },
    },
     computed:{
      filter(){        
        let tingkat = null, jurusan = null;
        let ar = this.toggle_tingkat;
        if(ar <= 3){tingkat = ar} 
        else if(ar === 7){tingkat = ar}
        else{jurusan = ar}
        return {tingkat: tingkat, jurusan:jurusan};
      }
    },
    mounted(){ 
      model.tingkats().then(data=>{this.tingkats = data});     
      model.paymentStatus().then(data=>{this.status = data});
      model.paymentTypes().then(data=>{this.types = data});   
      this.init(1, '', this.toggle_tingkat);    
    },            
    methods: {      
        format(tgl) { return this.$moment(tgl).format('DD-MM-YYYY')},
        
        getColor(tingkat){
          switch(tingkat){case 1:return 'red darken-2'; case 2: return 'indigo'; case 3:return 'blue-grey'; case 7:return 'light-green'; default:return 'blue-grey';}
        },
        
        getQuranWarna(status){
          switch(status){case 0:return 'yellow darken-2'; case 1: return 'green darken-2'; case -1:return 'red darken-2'; default:return 'blue-grey';}
        },
        
        getQuranStatus(status){
          switch(status){case 0:return 'mengulang'; case 1: return 'lulus'; case -1:return 'tidak lulus'; default:return '';}
        },
        
         searchTerm:debounce(function (newText) {         
          this.init(this.complex.pagination.currentPage, this.toggle_gender, this.filter.tingkat, this.filter.jurusan)                         
        }, 500),

        init(page = 1, gender='', tingkat='', jurusan_id=''){
          this.complex.loading = true
          model.settings({key:'rapor_'+this.toggle_tingkat}).then(data=>{            
            this.rapors = data.value;             
            
            let  sortby = this.complex.options.sortBy ? this.complex.options.descending ? 
              '-'+this.complex.options.sortBy : this.complex.options.sortBy : 'id'; 

            const params = {
              perPage: 20,
              page: page,
              expand:'calonTest',
              'UserCalonSearch[nama]': this.search,
              'UserCalonSearch[gender]': gender,
              'UserCalonSearch[tingkat_id]': tingkat,
              'UserCalonSearch[jurusan_id]': jurusan_id,
              sort:sortby,              
            }
            this.complex.items = [];
            model.indexRapor(params).then(res => {                      
              res.data.forEach(item=>{
                let raporEx = item.calonTest ? (item.calonTest.rapors?item.calonTest.rapors:[]):[];
                item.calonTest = item.calonTest ? item.calonTest : {};
                item.calonTest.rapors = []; 
                if(Array.isArray(this.rapors)){
                  this.rapors.forEach((rapor, i)=>{
                    let raportemp = raporEx.find(x=>x.id==rapor.id);
                    let childtemp = [];
                    rapor.childs.forEach((child,j) => {
                      let nilaichild = null;
                      if(raportemp && raportemp.childs.find(x=>x.id==child.id)){
                        nilaichild = raportemp.childs.find(x=>x.id==child.id).nilai;
                      }
                      childtemp.push({id:child.id, name:child.name, nilai: nilaichild});
                    });
                    item.calonTest.rapors.push({id:rapor.id,name:rapor.name,nilai:(raportemp?raportemp.nilai:null) ,childs:childtemp});                    
                  })
                }                
              });
              this.complex.items = res.data; 
              this.complex.pagination.pageCount = res.pagination.pageCount;  
              this.complex.loading = false;
            });                                         
          });          
        },                                                                                        

        save(){
          model.saveRapor({data:this.data}).then((res)=>{
            if(res.status === 200){
              this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                              
              //this.init(1, '', this.toggle_tingkat);
            }
          });
        },
        
        setData(fm){
          let calonTest = this.data.find(x=>x.calon_id === fm.id);
          fm.calonTest.rapors.forEach(item=>{
            let subtotal = 0;
            item.childs.forEach(child=>{
              subtotal += parseFloat(child.nilai);
            });
            item.nilai = subtotal/item.childs.length;
          });          
          if(calonTest){
            calonTest.rapors = fm.calonTest.rapors;            
          }else{            
            this.data.push({calon_id:fm.id, rapors:fm.calonTest.rapors});
          }
        }
    }
}
</script>
<style>
.v-radio label{font-size:13px}  
.tabular table.v-table tbody td:first-child, .tabular table.v-table tbody td:not(:first-child), .tabular table.v-table tfoot td:first-child, .tabular table.v-table tfoot td:not(:first-child), .tabular table.v-table tbody th:first-child, .tabular table.v-table tbody th:not(:first-child), .tabular table.v-table thead td:first-child, .tabular table.v-table thead td:not(:first-child), .tabular table.v-table thead th:first-child, .tabular table.v-table thead th:not(:first-child) {
    padding: 0 4px;
}
.tabular table.v-table tbody td:first-child, .tabular table.v-table thead th:first-child{
    padding: 0 5px 0 9px
}
.tb-normal{    
  border-collapse: collapse;
}
.tb-normal td, .tb-normal th {
  border: 1px solid #ddd;
  padding: 4px 6px;
}
</style>